import styled from 'styled-components';
import PropTypes from 'prop-types';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import React from 'react';
import { connect } from 'react-redux';
import { BaseComponent } from '../../../components/BaseComponent';
import { selectProductFilter } from '../selectors';
import { ProductSearchText } from './SearchText';

const STATE = {};
/* eslint-disable react/prefer-stateless-function */
class ProductSearchComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {}

  render() {
    if (!this.props.filter) return null;
    return <ProductSearchText filter={this.props.filter} />;
  }
}

ProductSearchComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    filter: selectProductFilter(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const ProductSearch = compose(withConnect, withRouter)(ProductSearchComp);
